import {
  BillingType,
  BusinessType,
  EnvironmentType,
  EventCompletionStatus,
  MaturityLevel,
  MemberAccess,
  OrganisationType,
  PlanType,
  Role,
  ServiceModel,
} from 'src/graphql/_generated';
import {
  ControllStatus,
  IncidentType,
  RiskConsequences,
  RiskEvents,
  RiskSources,
  SortType,
  Strategy,
  WorkspaceType,
} from './types';
import _ from 'lodash';

export const riskSourcesNames = {
  [RiskSources.Disgruntled]: 'Disgruntled',
  [RiskSources.Accidental]: 'Accidental',
  [RiskSources.Ineffective]: 'Ineffective',
  [RiskSources.Criminal]: 'Criminal',
  [RiskSources.Coerced]: 'Coerced',
  [RiskSources.Criminals]: 'Criminals',
  [RiskSources.Hacktivists]: 'Hacktivists',
  [RiskSources.Compromised]: 'Compromised suppliers',
  [RiskSources.StateSponsored]: 'State-Sponsored',
  [RiskSources.Competitor]: 'Competitor',
  [RiskSources.Press]: 'Press',
  [RiskSources.Researcher]: 'Researcher',
  [RiskSources.Regulator]: 'Regulator',
};

export const riskSourcesOptions = [
  {
    label: 'Internal',
    options: [
      { label: riskSourcesNames[RiskSources.Disgruntled], value: RiskSources.Disgruntled },
      { label: riskSourcesNames[RiskSources.Accidental], value: RiskSources.Accidental },
      { label: riskSourcesNames[RiskSources.Ineffective], value: RiskSources.Ineffective },
      { label: riskSourcesNames[RiskSources.Criminal], value: RiskSources.Criminal },
      { label: riskSourcesNames[RiskSources.Coerced], value: RiskSources.Coerced },
    ],
  },
  {
    label: 'External',
    options: [
      { label: riskSourcesNames[RiskSources.Criminals], value: RiskSources.Criminals },
      { label: riskSourcesNames[RiskSources.Hacktivists], value: RiskSources.Hacktivists },
      { label: riskSourcesNames[RiskSources.Compromised], value: RiskSources.Compromised },
      { label: riskSourcesNames[RiskSources.StateSponsored], value: RiskSources.StateSponsored },
      { label: riskSourcesNames[RiskSources.Competitor], value: RiskSources.Competitor },
      { label: riskSourcesNames[RiskSources.Press], value: RiskSources.Press },
      { label: riskSourcesNames[RiskSources.Researcher], value: RiskSources.Researcher },
      { label: riskSourcesNames[RiskSources.Regulator], value: RiskSources.Regulator },
    ],
  },
];

export const riskEventsNames = {
  [RiskEvents.ServiceUnavailability]: 'Service Unavailability',
  [RiskEvents.ServiceCompromise]: 'Service Compromise',
  [RiskEvents.InformationBreach]: 'Information Breach',
  [RiskEvents.AccessToOurSystemBreach]: 'Access to Our System Breach',
  [RiskEvents.ComplianceFailure]: 'Compliance Failure',
  [RiskEvents.RulesChange]: 'Rules Change',
  [RiskEvents.CriticalVulnerabilityPublished]: 'Critical Vulnerability Published',
  [RiskEvents.ChildSexualViolentContent]: 'Child / Sexual / Violent Content',
  [RiskEvents.HarmfulSpeech]: 'Harmful Speech',
  [RiskEvents.Harassment]: 'Harassment',
  [RiskEvents.Ransomware]: 'Ransomware',
  [RiskEvents.Worm]: 'Worm',
  [RiskEvents.Spyware]: 'Spyware',
  [RiskEvents.Rootkit]: 'Rootkit',
  [RiskEvents.Dialler]: 'Dialler',
  [RiskEvents.Sabotage]: 'Sabotage',
  [RiskEvents.DistributedDenialOfService]: 'Distributed / Denial of Service',
  [RiskEvents.OpenSourceIntelligenceAnalysis]: 'Open Source Intelligence Analysis',
  [RiskEvents.NetworkScanning]: 'Network Scanning',
  [RiskEvents.NetworkSniffing]: 'Network Sniffing',
  [RiskEvents.Lies]: 'Lies',
  [RiskEvents.Threats]: 'Threats',
  [RiskEvents.Phishing]: 'Phishing',
  [RiskEvents.Bribes]: 'Bribes',
  [RiskEvents.UnauthorisedAccessToInformation]: 'Unauthorised access to information',
  [RiskEvents.UnauthorisedSharingOfInformation]: 'Unauthorised sharing of information',
  [RiskEvents.UnauthorisedModificationOfInformation]: 'Unauthorised modification of information',
  [RiskEvents.UnauthorisedDeletionOfInformation]: 'Unauthorised deletion of information',
  [RiskEvents.UnauthorisedAccessToSystemComponent]: 'Unauthorised access to system / component',
  [RiskEvents.MisappropriationMisuseOfResources]: 'Misappropriation / misuse of resources',
  [RiskEvents.FalseRepresentation]: 'False representation',
  [RiskEvents.TheftOfMoney]: 'Theft of money',
  [RiskEvents.CrossSiteScripting]: 'Cross-site scripting (XSS)',
  [RiskEvents.FileInclusion]: 'File Inclusion',
  [RiskEvents.ControlSystemBypass]: 'Control System Bypass',
  [RiskEvents.UseOfStolenCredentials]: 'Use of stolen credentials',
  [RiskEvents.PasswordBruteForce]: 'Password brute force',
  [RiskEvents.SoftwareExploit]: 'Software Exploit',
  [RiskEvents.SQLInjection]: 'SQL injection',
  [RiskEvents.ProcessFailure]: 'Process failure',
  [RiskEvents.AuditFailure]: 'Audit Failure',
};

export const riskEventsOptions = [
  {
    label: 'Supplier',
    options: [
      { label: riskEventsNames[RiskEvents.ServiceUnavailability], value: RiskEvents.ServiceUnavailability },
      { label: riskEventsNames[RiskEvents.ServiceCompromise], value: RiskEvents.ServiceCompromise },
      { label: riskEventsNames[RiskEvents.InformationBreach], value: RiskEvents.InformationBreach },
      { label: riskEventsNames[RiskEvents.AccessToOurSystemBreach], value: RiskEvents.AccessToOurSystemBreach },
      { label: riskEventsNames[RiskEvents.ComplianceFailure], value: RiskEvents.ComplianceFailure },
    ],
  },
  {
    label: 'Regulatory',
    options: [{ label: riskEventsNames[RiskEvents.RulesChange], value: RiskEvents.RulesChange }],
  },
  {
    label: 'Research',
    options: [
      {
        label: riskEventsNames[RiskEvents.CriticalVulnerabilityPublished],
        value: RiskEvents.CriticalVulnerabilityPublished,
      },
    ],
  },
  {
    label: 'Abusive Content',
    options: [
      { label: riskEventsNames[RiskEvents.HarmfulSpeech], value: RiskEvents.HarmfulSpeech },
      { label: riskEventsNames[RiskEvents.ChildSexualViolentContent], value: RiskEvents.ChildSexualViolentContent },
      { label: riskEventsNames[RiskEvents.Harassment], value: RiskEvents.Harassment },
    ],
  },
  {
    label: 'Malware',
    options: [
      { label: riskEventsNames[RiskEvents.Ransomware], value: RiskEvents.Ransomware },
      { label: riskEventsNames[RiskEvents.Worm], value: RiskEvents.Worm },
      { label: riskEventsNames[RiskEvents.Spyware], value: RiskEvents.Spyware },
      { label: riskEventsNames[RiskEvents.Rootkit], value: RiskEvents.Rootkit },
      { label: riskEventsNames[RiskEvents.Dialler], value: RiskEvents.Dialler },
    ],
  },
  {
    label: 'Availability Interruption',
    options: [
      { label: riskEventsNames[RiskEvents.DistributedDenialOfService], value: RiskEvents.DistributedDenialOfService },
      { label: riskEventsNames[RiskEvents.Sabotage], value: RiskEvents.Sabotage },
    ],
  },
  {
    label: 'Information Gathering',
    options: [
      {
        label: riskEventsNames[RiskEvents.OpenSourceIntelligenceAnalysis],
        value: RiskEvents.OpenSourceIntelligenceAnalysis,
      },
      { label: riskEventsNames[RiskEvents.NetworkScanning], value: RiskEvents.NetworkScanning },
      { label: riskEventsNames[RiskEvents.NetworkSniffing], value: RiskEvents.NetworkSniffing },
    ],
  },
  {
    label: 'Social Engineering',
    options: [
      { label: riskEventsNames[RiskEvents.Lies], value: RiskEvents.Lies },
      { label: riskEventsNames[RiskEvents.Threats], value: RiskEvents.Threats },
      { label: riskEventsNames[RiskEvents.Phishing], value: RiskEvents.Phishing },
      { label: riskEventsNames[RiskEvents.Bribes], value: RiskEvents.Bribes },
    ],
  },
  {
    label: 'Information Breach',
    options: [
      {
        label: riskEventsNames[RiskEvents.UnauthorisedAccessToSystemComponent],
        value: RiskEvents.UnauthorisedAccessToSystemComponent,
      },
      {
        label: riskEventsNames[RiskEvents.UnauthorisedAccessToInformation],
        value: RiskEvents.UnauthorisedAccessToInformation,
      },
      {
        label: riskEventsNames[RiskEvents.UnauthorisedSharingOfInformation],
        value: RiskEvents.UnauthorisedSharingOfInformation,
      },
      {
        label: riskEventsNames[RiskEvents.UnauthorisedModificationOfInformation],
        value: RiskEvents.UnauthorisedModificationOfInformation,
      },
      {
        label: riskEventsNames[RiskEvents.UnauthorisedDeletionOfInformation],
        value: RiskEvents.UnauthorisedDeletionOfInformation,
      },
    ],
  },
  {
    label: 'Fraud',
    options: [
      {
        label: riskEventsNames[RiskEvents.MisappropriationMisuseOfResources],
        value: RiskEvents.MisappropriationMisuseOfResources,
      },
      { label: riskEventsNames[RiskEvents.FalseRepresentation], value: RiskEvents.FalseRepresentation },
      { label: riskEventsNames[RiskEvents.TheftOfMoney], value: RiskEvents.TheftOfMoney },
    ],
  },
  {
    label: 'System Intrusion',
    options: [
      { label: riskEventsNames[RiskEvents.SoftwareExploit], value: RiskEvents.SoftwareExploit },
      { label: riskEventsNames[RiskEvents.SQLInjection], value: RiskEvents.SQLInjection },
      { label: riskEventsNames[RiskEvents.CrossSiteScripting], value: RiskEvents.CrossSiteScripting },
      { label: riskEventsNames[RiskEvents.FileInclusion], value: RiskEvents.FileInclusion },
      { label: riskEventsNames[RiskEvents.ControlSystemBypass], value: RiskEvents.ControlSystemBypass },
      { label: riskEventsNames[RiskEvents.UseOfStolenCredentials], value: RiskEvents.UseOfStolenCredentials },
      { label: riskEventsNames[RiskEvents.PasswordBruteForce], value: RiskEvents.PasswordBruteForce },
    ],
  },
  {
    label: 'Governance Failure',
    options: [
      { label: riskEventsNames[RiskEvents.ProcessFailure], value: RiskEvents.ProcessFailure },
      { label: riskEventsNames[RiskEvents.AuditFailure], value: RiskEvents.AuditFailure },
    ],
  },
];

export const riskConsequencesNames = {
  [RiskConsequences.ReducedGrowth]: 'Reduced growth',
  [RiskConsequences.BusinessDisruption]: 'Business Disruption',
  [RiskConsequences.IneffectiveChange]: 'Ineffective Change',
  [RiskConsequences.SlowRecovery]: 'Slow recovery',
  [RiskConsequences.ReducedAccessToStaffSkills]: 'Reduced access to staff / skills',
  [RiskConsequences.LossOfSuppliers]: 'Loss of suppliers',
  [RiskConsequences.EnvironmentalHarm]: 'Environmental harm',
  [RiskConsequences.SafetyFailure]: 'Safety failure',
  [RiskConsequences.SocialHarm]: 'Social harm',
  [RiskConsequences.MedicalHarm]: 'Medical harm',
  [RiskConsequences.NonCompliance]: 'Non-compliance',
  [RiskConsequences.PoorConductIntegrity]: 'Poor conduct / integrity',
  [RiskConsequences.DamagedRegulatorRelations]: 'Damaged regulator relations',
  [RiskConsequences.RegulatoryFines]: 'Regulatory fines',
  [RiskConsequences.LegalChallenge]: 'Legal challenge',
  [RiskConsequences.TheftOfMoney]: 'Theft of money',
  [RiskConsequences.UnplannedCosts]: 'Unplanned costs',
  [RiskConsequences.IncreasedCostsInefficiency]: 'Increased costs / inefficiency',
  [RiskConsequences.DamagedReputation]: 'Damaged reputation',
  [RiskConsequences.EmbarrassingReporting]: 'Embarrassing reporting',
  [RiskConsequences.DamagedInvestorRelations]: 'Damaged investor relations',
};

export const riskConsequencesOptions = [
  {
    label: 'Operations',
    options: [
      { label: riskConsequencesNames[RiskConsequences.ReducedGrowth], value: RiskConsequences.ReducedGrowth },
      { label: riskConsequencesNames[RiskConsequences.BusinessDisruption], value: RiskConsequences.BusinessDisruption },
      { label: riskConsequencesNames[RiskConsequences.IneffectiveChange], value: RiskConsequences.IneffectiveChange },
      { label: riskConsequencesNames[RiskConsequences.SlowRecovery], value: RiskConsequences.SlowRecovery },
      {
        label: riskConsequencesNames[RiskConsequences.ReducedAccessToStaffSkills],
        value: RiskConsequences.ReducedAccessToStaffSkills,
      },
      { label: riskConsequencesNames[RiskConsequences.LossOfSuppliers], value: RiskConsequences.LossOfSuppliers },
      { label: riskConsequencesNames[RiskConsequences.EnvironmentalHarm], value: RiskConsequences.EnvironmentalHarm },
      { label: riskConsequencesNames[RiskConsequences.SafetyFailure], value: RiskConsequences.SafetyFailure },
      { label: riskConsequencesNames[RiskConsequences.SocialHarm], value: RiskConsequences.SocialHarm },
      { label: riskConsequencesNames[RiskConsequences.MedicalHarm], value: RiskConsequences.MedicalHarm },
    ],
  },
  {
    label: 'Compliance',
    options: [
      { label: riskConsequencesNames[RiskConsequences.NonCompliance], value: RiskConsequences.NonCompliance },
      {
        label: riskConsequencesNames[RiskConsequences.PoorConductIntegrity],
        value: RiskConsequences.PoorConductIntegrity,
      },
      {
        label: riskConsequencesNames[RiskConsequences.DamagedRegulatorRelations],
        value: RiskConsequences.DamagedRegulatorRelations,
      },
      { label: riskConsequencesNames[RiskConsequences.RegulatoryFines], value: RiskConsequences.RegulatoryFines },
      { label: riskConsequencesNames[RiskConsequences.LegalChallenge], value: RiskConsequences.LegalChallenge },
    ],
  },
  {
    label: 'Financial',
    options: [
      { label: riskConsequencesNames[RiskConsequences.TheftOfMoney], value: RiskConsequences.TheftOfMoney },
      { label: riskConsequencesNames[RiskConsequences.UnplannedCosts], value: RiskConsequences.UnplannedCosts },
      {
        label: riskConsequencesNames[RiskConsequences.IncreasedCostsInefficiency],
        value: RiskConsequences.IncreasedCostsInefficiency,
      },
    ],
  },
  {
    label: 'Strategic',
    options: [
      { label: riskConsequencesNames[RiskConsequences.DamagedReputation], value: RiskConsequences.DamagedReputation },
      {
        label: riskConsequencesNames[RiskConsequences.EmbarrassingReporting],
        value: RiskConsequences.EmbarrassingReporting,
      },
      {
        label: riskConsequencesNames[RiskConsequences.DamagedInvestorRelations],
        value: RiskConsequences.DamagedInvestorRelations,
      },
    ],
  },
];

export const incidentTypeNames = {
  [IncidentType['Near miss']]: 'Near miss',
  [IncidentType.Incident]: 'Incident',
};

export const incidentTypeOptions = [
  { value: IncidentType.Incident, label: incidentTypeNames[IncidentType.Incident] },
  { value: IncidentType['Near miss'], label: incidentTypeNames[IncidentType['Near miss']] },
];

export const strategyOptions = [
  { label: Strategy.Treat, value: Strategy.Treat },
  { label: Strategy.Transfer, value: Strategy.Transfer },
  { label: Strategy.Tolerate, value: Strategy.Tolerate },
  { label: Strategy.Terminate, value: Strategy.Terminate },
];

export const controllStatusNames = {
  [ControllStatus.NotStarted]: 'Not started',
  [ControllStatus.InProgress]: 'In progress',
  [ControllStatus.Live]: 'Live',
  [ControllStatus.Abandoned]: 'Abandoned',
  [ControllStatus.Retired]: 'Retired',
};

export const controllStatusOptions = [
  { label: controllStatusNames[ControllStatus.NotStarted], value: ControllStatus.NotStarted },
  { label: controllStatusNames[ControllStatus.InProgress], value: ControllStatus.InProgress },
  { label: controllStatusNames[ControllStatus.Live], value: ControllStatus.Live },
  { label: controllStatusNames[ControllStatus.Abandoned], value: ControllStatus.Abandoned },
  { label: controllStatusNames[ControllStatus.Retired], value: ControllStatus.Retired },
];

export const WorkspaceTypeNames = {
  [WorkspaceType.Paid]: 'Paid',
  [WorkspaceType.Trial]: 'Trial',
  [WorkspaceType.ExtendedTrial]: 'Extended Trial',
  [WorkspaceType.Partner]: 'Partner',
  [WorkspaceType.Demo]: 'Demo',
  [WorkspaceType.Internal]: 'Internal',
  [WorkspaceType.Idle]: 'Idle',
  [WorkspaceType.Closed]: 'Closed',
};

export const workspaceTypeOptions = [
  { label: WorkspaceTypeNames[WorkspaceType.Paid], value: WorkspaceType.Paid },
  { label: WorkspaceTypeNames[WorkspaceType.Trial], value: WorkspaceType.Trial },
  { label: WorkspaceTypeNames[WorkspaceType.ExtendedTrial], value: WorkspaceType.ExtendedTrial },
  { label: WorkspaceTypeNames[WorkspaceType.Partner], value: WorkspaceType.Partner },
  { label: WorkspaceTypeNames[WorkspaceType.Demo], value: WorkspaceType.Demo },
  { label: WorkspaceTypeNames[WorkspaceType.Internal], value: WorkspaceType.Internal },
  { label: WorkspaceTypeNames[WorkspaceType.Idle], value: WorkspaceType.Idle },
  { label: WorkspaceTypeNames[WorkspaceType.Closed], value: WorkspaceType.Closed },
];

export const restrictAccessOptions = [
  { label: 'Restricted', value: true },
  { label: 'Open', value: false },
];

export const orgTreeItemTypeNames = {
  W: 'Workspace',
  O: 'Organisation',
};

export const sortOptions = [
  { label: 'Sort by Date Created', value: SortType.ByCreatedDate, dir: 'desc' },
  { label: 'Sort by Review Date', value: SortType.ByReviewDate, dir: 'asc' },
  { label: 'Sort by Expected Loss', value: SortType.ByExpectedLoss, dir: 'desc' },
  { label: 'Sort by Number of Scenarios', value: SortType.ByNumberOfScenarios, dir: 'desc' },
  { label: 'Sort by Alphabetical Order', value: SortType.ByName, dir: 'asc' },
  { label: 'Sort by Last Edited', value: SortType.EditedAt, dir: 'desc' },
  { label: 'Sort by Last Updated', value: SortType.UpdatedAt, dir: 'desc' },
];

export const scenarioStatusNames = {
  Archived: 'Archived',
  Closed: 'Closed',
  Draft: 'Draft',
  Open: 'Open',
};

export const scenarioStatusOptions = [
  { label: 'Draft', value: 'Draft' },
  { label: 'Open', value: 'Open' },
  { label: 'Closed', value: 'Closed' },
  // { label: 'Archived', value: 'Archived' },
];

export const maturityLevelNames = {
  [MaturityLevel.Level_0]: '0',
  [MaturityLevel.Level_1]: '1',
  [MaturityLevel.Level_2]: '2',
  [MaturityLevel.Level_3]: '3',
  [MaturityLevel.Level_4]: '4',
  [MaturityLevel.Level_5]: '5',
};

export const maturityLevelOptions = [
  { label: maturityLevelNames[MaturityLevel.Level_0], value: MaturityLevel.Level_0 },
  { label: maturityLevelNames[MaturityLevel.Level_1], value: MaturityLevel.Level_1 },
  { label: maturityLevelNames[MaturityLevel.Level_2], value: MaturityLevel.Level_2 },
  { label: maturityLevelNames[MaturityLevel.Level_3], value: MaturityLevel.Level_3 },
  { label: maturityLevelNames[MaturityLevel.Level_4], value: MaturityLevel.Level_4 },
  { label: maturityLevelNames[MaturityLevel.Level_5], value: MaturityLevel.Level_5 },
];

export const getMaturityLevelName = (level?: MaturityLevel | null) => {
  if (_.isNil(level)) return '';
  return maturityLevelNames[level];
};

export const getScenarioStatusName = (status?: string | null) => {
  if (_.isNil(status)) return '';
  return scenarioStatusNames[status as keyof typeof scenarioStatusNames];
};

export const getMemberAccessLabel = (access?: MemberAccess | null) => {
  if (_.isNil(access)) return '';
  const labels: Record<MemberAccess, string> = {
    [MemberAccess.Allowed]: 'Allowed',
    [MemberAccess.Blocked]: 'Blocked',
    [MemberAccess.Requested]: 'Requested',
    [MemberAccess.AdminOnly]: 'Admin Only',
    [MemberAccess.Invited]: 'Invited',
    [MemberAccess.None]: 'None',
    [MemberAccess.Restricted]: 'Restricted',
  };
  return labels[access];
};

export const getRoleLabel = (role?: Role | null) => {
  if (!role) return '';

  const roleNames = {
    [Role.WorkspaceAdmin]: 'Workspace Administrator',
    [Role.OrganisationAdmin]: 'Organisation Administrator',
    [Role.Collaborator]: 'Collaborator',
    [Role.NoAccess]: 'Blocked',
    [Role.PartnerBranchAdmin]: 'Partner Branch Administrator',
    [Role.CustomerManager]: 'Customer Manager',
    [Role.PlatformAdmin]: 'Platform Administrator',
  };

  return roleNames[role];
};

export const roleOptions = [
  { label: getRoleLabel(Role.Collaborator), value: Role.Collaborator },
  // { label: getRoleLabel(Role.CustomerManager), value: Role.CustomerManager },
  { label: getRoleLabel(Role.NoAccess), value: Role.NoAccess },
  { label: getRoleLabel(Role.OrganisationAdmin), value: Role.OrganisationAdmin },
  { label: getRoleLabel(Role.PartnerBranchAdmin), value: Role.PartnerBranchAdmin },
  { label: getRoleLabel(Role.WorkspaceAdmin), value: Role.WorkspaceAdmin },
];

export const getRiskConsequencesName = (consequence?: RiskConsequences | null) => {
  if (_.isNil(consequence)) return '';
  return riskConsequencesNames[consequence];
};

export const getRiskEventsName = (event?: RiskEvents | null) => {
  if (_.isNil(event)) return '';
  return riskEventsNames[event];
};

export const getRiskSourcesName = (source?: RiskSources | null) => {
  if (_.isNil(source)) return '';
  return riskSourcesNames[source];
};

export const getEventCompletionStatusLabel = (status?: EventCompletionStatus | null) => {
  if (_.isNil(status)) return '';
  return status === EventCompletionStatus.Done ? 'Completed' : 'Incomplete';
};

export const eventCompletionStatusOptions = [
  { label: getEventCompletionStatusLabel(EventCompletionStatus.Done), value: EventCompletionStatus.Done },
  { label: getEventCompletionStatusLabel(EventCompletionStatus.Open), value: EventCompletionStatus.Open },
];

export const getOrganisationTypeLabel = (type?: OrganisationType | null): string => {
  const labels: Record<OrganisationType, string> = {
    [OrganisationType.CydeaConsulting]: 'Cydea Consulting',
    [OrganisationType.CydeaPlatform]: 'Cydea Platform',
    [OrganisationType.DirectCustomer]: 'Direct Customer',
    [OrganisationType.Partner]: 'Partner',
    [OrganisationType.PartnerCustomer]: 'Partner Customer',
  };

  if (_.isNil(type)) return '';

  return labels[type] || '';
};

export const organisationTypeOptions: { value: OrganisationType; label: string }[] = [
  { value: OrganisationType.CydeaConsulting, label: getOrganisationTypeLabel(OrganisationType.CydeaConsulting) },
  { value: OrganisationType.CydeaPlatform, label: getOrganisationTypeLabel(OrganisationType.CydeaPlatform) },
  { value: OrganisationType.DirectCustomer, label: getOrganisationTypeLabel(OrganisationType.DirectCustomer) },
  { value: OrganisationType.Partner, label: getOrganisationTypeLabel(OrganisationType.Partner) },
  { value: OrganisationType.PartnerCustomer, label: getOrganisationTypeLabel(OrganisationType.PartnerCustomer) },
];

export const getBusinessTypeLabel = (type?: BusinessType | null): string => {
  const labels: Record<BusinessType, string> = {
    [BusinessType.Company]: 'Company',
    [BusinessType.ConsultingPartner]: 'Consulting Partner',
    [BusinessType.InsuranceBroker]: 'Insurance Broker',
    [BusinessType.InsuranceUnderwriter]: 'Insurance Underwriter',
    [BusinessType.Internal]: 'Internal',
    [BusinessType.MspMssp]: 'MSP/MSSP',
    [BusinessType.PortfolioCompany]: 'Portfolio Company',
    [BusinessType.PrivateEquity]: 'Private Equity',
  };

  if (_.isNil(type)) return '';

  return labels[type] || '';
};

export const businessTypeOptions: { value: BusinessType; label: string }[] = [
  { value: BusinessType.Company, label: getBusinessTypeLabel(BusinessType.Company) },
  { value: BusinessType.ConsultingPartner, label: getBusinessTypeLabel(BusinessType.ConsultingPartner) },
  { value: BusinessType.InsuranceBroker, label: getBusinessTypeLabel(BusinessType.InsuranceBroker) },
  { value: BusinessType.InsuranceUnderwriter, label: getBusinessTypeLabel(BusinessType.InsuranceUnderwriter) },
  { value: BusinessType.Internal, label: getBusinessTypeLabel(BusinessType.Internal) },
  { value: BusinessType.MspMssp, label: getBusinessTypeLabel(BusinessType.MspMssp) },
  { value: BusinessType.PortfolioCompany, label: getBusinessTypeLabel(BusinessType.PortfolioCompany) },
  { value: BusinessType.PrivateEquity, label: getBusinessTypeLabel(BusinessType.PrivateEquity) },
];

export const getBillingTypeLabel = (type?: BillingType | null): string => {
  const labels: Record<BillingType, string> = {
    [BillingType.Channel]: 'Channel',
    [BillingType.Direct]: 'Direct',
    [BillingType.NoBilling]: 'No Billing',
  };

  if (_.isNil(type)) return '';

  return labels[type] || '';
};

export const billingTypeOptions: { value: BillingType; label: string }[] = [
  { value: BillingType.Channel, label: getBillingTypeLabel(BillingType.Channel) },
  { value: BillingType.Direct, label: getBillingTypeLabel(BillingType.Direct) },
  { value: BillingType.NoBilling, label: getBillingTypeLabel(BillingType.NoBilling) },
];

export const getServiceModelLabel = (model?: ServiceModel | null): string => {
  const labels: Record<ServiceModel, string> = {
    [ServiceModel.ConsultingOnly]: 'Consulting Only',
    [ServiceModel.PlatformAndConsulting]: 'Platform and Consulting',
    [ServiceModel.PlatformOnly]: 'Platform Only',
  };

  if (_.isNil(model)) return '';

  return labels[model] || '';
};

export const serviceModelOptions: { value: ServiceModel; label: string }[] = [
  { value: ServiceModel.ConsultingOnly, label: getServiceModelLabel(ServiceModel.ConsultingOnly) },
  { value: ServiceModel.PlatformAndConsulting, label: getServiceModelLabel(ServiceModel.PlatformAndConsulting) },
  { value: ServiceModel.PlatformOnly, label: getServiceModelLabel(ServiceModel.PlatformOnly) },
];

export const getPlanTypeLabel = (type?: PlanType | null): string => {
  const labels: Record<PlanType, string> = {
    [PlanType.EnterprisePlan]: 'Enterprise Plan',
    [PlanType.ProfessionalPlan]: 'Professional Plan',
    [PlanType.StarterPlan]: 'Starter Plan',
  };

  if (_.isNil(type)) return '';

  return labels[type] || '';
};

export const planTypeOptions: { value: PlanType; label: string }[] = [
  { value: PlanType.EnterprisePlan, label: getPlanTypeLabel(PlanType.EnterprisePlan) },
  { value: PlanType.ProfessionalPlan, label: getPlanTypeLabel(PlanType.ProfessionalPlan) },
  { value: PlanType.StarterPlan, label: getPlanTypeLabel(PlanType.StarterPlan) },
];

export const getEnvironmentTypeLabel = (type?: EnvironmentType | null): string => {
  const labels: Record<EnvironmentType, string> = {
    [EnvironmentType.Demo]: 'Demo',
    [EnvironmentType.Internal]: 'Internal',
    [EnvironmentType.Paid]: 'Paid',
    [EnvironmentType.Trial]: 'Trial',
  };

  if (_.isNil(type)) return '';

  return labels[type] || '';
};

export const environmentTypeOptions: { value: EnvironmentType; label: string }[] = [
  { value: EnvironmentType.Demo, label: getEnvironmentTypeLabel(EnvironmentType.Demo) },
  { value: EnvironmentType.Internal, label: getEnvironmentTypeLabel(EnvironmentType.Internal) },
  { value: EnvironmentType.Paid, label: getEnvironmentTypeLabel(EnvironmentType.Paid) },
  { value: EnvironmentType.Trial, label: getEnvironmentTypeLabel(EnvironmentType.Trial) },
];
